import React, { useState, useEffect, useRef } from 'react';
import _, { omit, remove, set } from 'lodash';
import useApi from '../api';
import { FormField } from '../types';
import { useOutsideAlerter } from '../useOutsideAlerter';
import CreateContent from './CreateContent';
import { ToastContainer, toast, ToastOptions } from 'react-toastify';
import toastConfig from '../config/Toast';


const DocContents = ({ docId, fields }: { docId: string | undefined, fields: FormField[] }) => {
  const [modalVisible, setModalVisible] = useState(false); // State to manage modal visibility
  const [contents, setContents] = useState<any[]>([]);
  const [activeContentId, setActiveContentId] = useState<string>('');
  const { get, getStream, post, postStream, put, patch, remove } = useApi();
  // console.log(owner)


  const toggleModal = (contentId?: string) => {
    if (activeContentId != "") {
      setActiveContentId('');
    } else if (contentId) {
      setActiveContentId(contentId);
    }
    setModalVisible(!modalVisible);
  };

  useEffect(() => {
    const fetchContents = async () => {
      try {
        const response = await get(`/content/?doc_id=${docId}`);
        console.log(response);
        setContents(response.data);
      } catch (error) {
        console.error('Error fetching contents:', error);
      }
    };
    fetchContents();
  }, []);

  const deleteContent = async (id: string) => {
    try {
      await remove(`/content/${id}`);
      setContents((prev) => prev.filter((content) => content.id !== id));
      toast.success('Content deleted successfully', toastConfig);
    } catch (error) {
      console.error('Error deleting content:', error);
    }
  };



  const modalRef = useRef(null);

  // useOutsideAlerter(modalRef, () => toggleModal());

  return (
    <div className=''>
      <label className="block text-sm font-medium leading-6 text-gray-900">
        Artifacts
      </label>
      <div onClick={() => toggleModal()} className="flex flex-row items-center mt-2 p-2 pl-2 border rounded-full hover:shadow-md hover:cursor-pointer border-dashed border-gray-400 w-11">

        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 stroke-gray-400">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59" />
        </svg>

      </div>
      {contents && contents.length > 0 && (
        <div className="flex flex-col mt-4">
          <div className="-m-1.5 overflow-x-auto">
            <div className="p-1.5 min-w-full flex flex-row space-x-4 align-middle">
              {contents.length > 0 &&
                contents.map((content: any) => (
                  <div className="border rounded-lg shadow p-4 flex flex-col justify-between leading-normal w-60">
       
                    <div className="2">
                      <div className="flex flex-row justify-between">
                      <div onClick={() => toggleModal(content.id)} className="text-gray-900 font-bold text-xl mb-2 hover:cursor-pointer hover:text-sky-800 ">{content.content.name}</div>
                      <div onClick={() => deleteContent(content.id)}>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 shrink-0 stroke-gray-400 hover:stroke-red-400 hover:cursor-pointer">
                    <path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                  </svg>
                  </div>
                  </div>

                      <p className="text-gray-700 text-base">{content.content.description}</p>
                    </div>

                  </div>

                ))}
            </div>
          </div>
        </div>
      )}

      {modalVisible && (

        <CreateContent
          contentId={activeContentId}
          docId={docId}
          fields={fields}
          modalRef={modalRef}
          toggleModal={toggleModal}
          modalVisible={modalVisible}
          setContents={setContents}
        />
      )}
    </div>
  );
};

export default DocContents;